export default {
  agencyFilterLabel: "Filter by agency",
  industryFilterLabel: "Filter by industry",
  subindustryFilterLabel: "Filter by Sub-Industry",
  agency: "Agency",
  user: "User",
  role: "Role",
  advertiser: "Advertiser",
  addNewLabel: (label: string): string => `Add New ${label}`,
  accountFilterLabel: "Filter by account",
  all: "All",
  accountLabel: "Account",
  accountsLabel: "Accounts",
  bottom: "Bottom",
  businessGoal: "Business Goal",
  bgNamePlaceholder: "Campaign ID | Business Goal",
  b2bb2c: "B2B/B2C",
  campaign: "Campaign",
  campaignBudget: "Campaign Budget",
  campaignIdLabel: "Campaign ID",
  channel: "Channel",
  dataType: "Data Type",
  gender: "Demo Gender",
  dateOfComparison: "Date of Comparison",
  ageGroup: "Demo Age Group",
  direction: "Direction",
  dma: "DMA",
  dsp: "DSP",
  pixelExperience: "Pixeling Experience",
  websiteConversion: "Website Conversion Experience",
  averageOrderValue: "Average Order Value",
  brandRecognition: "Brand Recognition",
  timeToConversion: "Estimated Time to Conversion",
  audienceSize: "Estimated Audience Size",
  chartType: "Chart Type",
  chartTitleLabel: "Chart Title",
  countryFilterLabel: "Filter by country",
  categoryLabel: "Category Label",
  date: "Date",
  owner: "Owner",
  editor: "Editor",
  viewer: "Viewer",
  funnelStageBudget: "Funnel Stage Budget",
  displayNameLabel: "Display Name",
  decompositionMetric: "Decomposition Metric",
  defaultNewPageName: "New Page",
  defaultNewPlanName: "New Plan",
  emailAddressLabel: "Email Address",
  industry: "Industry",
  projectDetails: "Project Details",
  businessGoalDetails: "Business Goal Details",
  items: "Items",
  left: "Left",
  subIndustry: "Sub-Industry",
  mediaType: "Media Type",
  menuViews: "Menu Views",
  month: "Month",
  order: "Order",
  otherEngagement: "Other Engagement",
  url: "URL",
  project: "Project",
  periodOverPeriod: "Period over period",
  planDefaultOutput: "Plan Default Output",
  nameDashboard: "Name your dashboard",
  namePlan: "Name your Plan",
  nameScenario: "Name your Scenario",
  quarter: "Quarter",
  right: "Right",
  scenarioDetails: "Scenario Details",
  scenarioSummary: "Scenario Summary",
  impressions: "Impressions",
  landingPageVisits: "Landing Page Visits",
  rowsPerPage: "Rows per page",
  search: "Search",
  states: "States",
  scenarioGranularity: "Time Granularity",
  flightCadence: "Flight Cadence",
  summaryTitleLabel: "Summary Title",
  icons: "Icons",
  legend: "Legend",
  top: "Top",
  top5: "Top 5",
  top8: "Top 8",
  top10: "Top 10",
  tableTitleLable: "Table Title",
  roleFilterLabel: "Filter by role",
  nullValues: "NULL values",
  store: "Store",
  targetValue: "Target Value",
  view: "View",
  websiteVisit: "Website Visit",
  week: "Week",
  year: "Year",
  yearOverYear: "Year over year",
  countSelected: (count: number): string => `${count} selected`,
  exploreAdvertiser: "Advertiser",
  projectContext: "Project Context",
  exploreFilters: "Explore Filters",
  dateRange: "Date Range",
  dataMode: "Data Source",
  dataModeProject: "Project data",
  dataModeExplore: "Explore data",
  dataModeDual: "Project + Explore",
  cities: "Cities",
  zips: "Zips",
};
